import React from "react";
import { useLocation } from "react-router-dom";

const Seller_tabs_list = () => {
  const location = useLocation();
  return (
    <>
      {/* Tab navlink starts here */}
      <div className="seller-tabs-list-wrapper">
        <ul>
          <li>
            <a
              className={
                location?.pathname == "/seller-dashboard"
                  ? "nav-item active"
                  : "nav-item"
              }
              href="/seller-dashboard"
            >
              Dashboard
            </a>
          </li>
          <li>
            <a
              className={
                location?.pathname == "/seller-customer"
                  ? "nav-item active"
                  : "nav-item"
              }
              href="/seller-customer"
            >
              Customer
            </a>
          </li>
          <li>
            <a
              className={
                location?.pathname == "/seller-Inventory"
                  ? "nav-item active"
                  : "nav-item"
              }
              href="/seller-Inventory"
            >
              Product Inventory
            </a>
          </li>
          <li>
            <a
              className={
                location?.pathname == "/seller-order"
                  ? "nav-item active"
                  : "nav-item"
              }
              href="/seller-order"
            >
              Orders
            </a>
          </li>
          <li>
            <a
              className={
                location?.pathname == "/seller-account"
                  ? "nav-item active"
                  : "nav-item"
              }
              href="/seller-account"
            >
              My Account
            </a>
          </li>
          <li>
            <a
              className={
                location?.pathname == "/seller-banner-ads"
                  ? "nav-item active"
                  : "nav-item"
              }
              href="/seller-banner-ads"
            >
              Banner Ads
            </a>
          </li>
          <li>
            <a
              className={
                location?.pathname == "/seller-reviews"
                  ? "nav-item active"
                  : "nav-item"
              }
              href="/seller-reviews"
            >
              Reviews
            </a>
          </li>
        </ul>
      </div>
      {/* Tab navlink ends here */}
    </>
  );
};

export default Seller_tabs_list;
